export const COMPONENT_MOUNTED = "/COMPONENT_MOUNTED";
export const componentMounted = ({ componentNamespace }) => ({
  type: componentNamespace + COMPONENT_MOUNTED,
});

export const COMPONENT_DISMOUNTED = "/COMPONENT_DISMOUNTED";
export const componentDismounted = ({ componentNamespace }) => ({
  type: componentNamespace + COMPONENT_DISMOUNTED,
});

export const namespaceToMountedActionType = ({ componentNamespace }) =>
  componentNamespace + COMPONENT_MOUNTED;

export const namespaceToUnmountedActionType = ({ componentNamespace }) =>
  componentNamespace + COMPONENT_DISMOUNTED;
